export default __webpack_public_path__ + "static/media/mana2u.2936999e.svg";